/* eslint-disable no-underscore-dangle */
// KU – adapted from Segment's Facebook Pixel integration
// https://github.com/segmentio/analytics.js-integrations/blob/5640364e519b9dd942c460821cf15ead76916aa9/integrations/facebook-pixel/lib/index.js

import {
  AnalyticsAction,
  INITIAL_SUBSCRIPTION,
  PAYMENT_METHOD_SUBMIT_CLICK,
  SIGNUP_AUTH_SUCCESS,
} from '../constants/analytics';
import { CookieName } from '../constants/cookie';
import { Path } from '../constants/router';
import { PixelEvent } from '../types/analytics';
import { getCookie } from './cookie';
import { injectPixel, isDoNotSellEnabled } from './pixel';
import { ROUTE_TITLES } from './router';

const PIXEL_ID = '140565826548701';
const PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
const PIXEL_VERSION = '2.0';

export const IGNORED_PAGES = new Set(
  [Path.AUTHENTICATE, Path.AUTHORIZE].map(it => ROUTE_TITLES[it]),
);

export const EVENTS: Record<string, string> = {
  [INITIAL_SUBSCRIPTION]: 'Subscribe',
  [PAYMENT_METHOD_SUBMIT_CLICK]: 'Subscribe',
  [SIGNUP_AUTH_SUCCESS]: 'CompleteRegistration',
  [AnalyticsAction.PAGE]: 'PageView',
};

export const SUBSCRIBE_EVENTS = [INITIAL_SUBSCRIPTION, PAYMENT_METHOD_SUBMIT_CLICK];

type GenericFunction = (...args: unknown[]) => void;
export interface FacebookPixel extends GenericFunction {
  allowDuplicatePageViews?: boolean;
  callMethod?: GenericFunction;
  disablePushState?: boolean;
  loaded?: boolean;
  push?: GenericFunction;
  queue?: unknown[];
  version?: string;
}

export function setupFBPixel() {
  if (window.fbq) {
    return;
  }

  window._fbq = function callMethod(...args) {
    if (window.fbq?.callMethod) {
      // eslint-disable-next-line prefer-spread
      window.fbq.callMethod.apply(window.fbq, args);
    } else {
      window.fbq?.queue?.push(args);
    }
  };

  window.fbq = window.fbq || window._fbq;
  window.fbq.push = window.fbq;
  window.fbq.version = PIXEL_VERSION;
  window.fbq.loaded = false;
  window.fbq.queue = [];

  // KU – enable Limited Data Use
  window.fbq('dataProcessingOptions', ['LDU'], 0, 0);
  // LB - disable automatic configurations
  window.fbq('set', 'autoConfig', false, PIXEL_ID);

  const externalId = getCookie({ name: CookieName.ANONYMOUS_ID, isJSON: false });

  window.fbq('init', PIXEL_ID, {
    external_id: externalId,
  });
}

export const track = ({ event, properties, eventId }: PixelEvent) => {
  const facebookEvent = EVENTS[event];
  if (!facebookEvent || isDoNotSellEnabled()) {
    return;
  }
  injectPixel(PIXEL_SRC);
  window.fbq?.('track', facebookEvent, properties, eventId);
  if (SUBSCRIBE_EVENTS.includes(event)) {
    window.fbq?.('track', 'Purchase', properties, eventId);
  }
};

export const page = ({ event: pageName }: PixelEvent) => {
  if (IGNORED_PAGES.has(pageName)) {
    return;
  }
  track({ event: AnalyticsAction.PAGE });
};
